import { render } from "./SelectCityPopup.vue?vue&type=template&id=188f8118&scoped=true"
import script from "./SelectCityPopup.vue?vue&type=script&lang=js"
export * from "./SelectCityPopup.vue?vue&type=script&lang=js"

import "./SelectCityPopup.vue?vue&type=style&index=0&id=188f8118&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188f8118"]])

export default __exports__